import {appendPaginationQueryParamsToUrl, get} from '../utils'

const url = (host, options) => appendPaginationQueryParamsToUrl(`${host}/musics?approved=false&created_by_artist=true&include=tags;albums.artist;audio:url,duration;audio.waveform;midLevelFeature;lowLevelFeature;artist`, {...options, alreadyHasQueryParams: true})

export default host => options =>
  get(url(host, options))
    .then(response => response.json())
    .then(json => json.meta ? json : json.data)
